<template>
  <div>
    <div style="display: flex;justify-content: center;align-items: center;">
      <dynamic-image v-if="doctor.profileImage" :file-id="doctor.profileImage" image-style="height: 10em;width: 10em;border-radius: 100%;">
      </dynamic-image>
      <i v-else class="fa fa-user-md" style="
                    background: var(--color-primary);
                    padding: 10px;
                    border-radius: 50%;
                    color: #fff;
                    font-size: 5em;
                    padding: 0.5em;
                  "></i>

    </div>
    <h6 class="card-title mt-3" style="text-align: center;">
      {{ $t("message.Dr") }}. {{ doctor.firstName }}
      {{ doctor.lastName }}
    </h6>
    <h6 class="card-subtitle mb-2 text-muted" style="font-size: smaller;text-align: center;">
      {{ doctor.specialityText || "--" }}
    </h6>
    <p class="card-text mb-0" v-if="doctor.registration.number">
      {{ $t("message.Reg No") }}:
      {{ doctor.registration.number }},
      {{ doctor.registration.city }}
    </p>
    <!--   <div style="display: flex" class="mb-2" v-show="
                    doctor.billingDetails.enabled &&
                    doctor.billingDetails.amount
                  ">
      <span>{{ $t("message.Consultation charges") }}</span>
      <div style="color: grey; float: right; border-radius: 10%" class="pl-2">
        <i :class="getCurrencyClass(doctor.billingDetails.currency)"></i>
        {{ doctor.billingDetails.amount || "--" }}
      </div>
    </div> -->
    <p class="card-text" v-if="doctor && doctor.description">{{ doctor.description || "--" }}</p>
    <div class="card-link text-center" style="bottom: 0px; width: 100%; left: 0px">
      <n-button id="InPerson" v-if="settings &&
                      settings.directBookings.inPersonBookingEnabled" type="primary" round simple @click.native="goToSlotSelection(doctor, 'InPerson')">{{ $t("message.Book In-Person Consultation") }}<span v-if="doctor.billingDetails &&
                    doctor.billingDetails.enabled &&
                    doctor.billingDetails.inpersonAppointmentAmount"> - <i :class="getCurrencyClass(doctor.billingDetails.currency)"></i>
          {{ doctor.billingDetails.inpersonAppointmentAmount}}</span></n-button>
      <n-button id="TeleConsult" type="primary" round @click.native="goToSlotSelection(doctor, 'TeleConsult')">{{ $t("message.Book Video Consultation") }}<span v-if="doctor.billingDetails &&
                    doctor.billingDetails.enabled &&
                    doctor.billingDetails.amount
                  "> - <i :class="getCurrencyClass(doctor.billingDetails.currency)"></i>
          {{ doctor.billingDetails.amount}}</span></n-button>
    </div>
  </div>
</template>

<script>
import ProfileImage from "./ProfileImage.vue";
export default {
  name: "doctor-card",

  props: ["doctor"],

  computed: {
    baseUrl() {
      return this.$store.state.baseUrl;
    },
  },
  components: {
    "profile-image": ProfileImage,
  },

  methods: {
    goToSlotSelection(doctor, type) {
      this.$store.commit("setState", {
        stateName: "selectedDoctor",
        stateValue: doctor,
      });

      this.$store.commit("setState", {
        stateName: "slotType",
        stateValue: type,
      });
      this.$router.push("/slots/" + doctor._id + "?type=" + type);
    },
  },
};
</script>

<style scoped>
.card {
  margin-bottom: unset;
  height: 100%;
}

/deep/.card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}
</style>
